import { useNotify, useRedirect } from "react-admin";

interface ICommonProps {
  basePath?: string;
  resource?: string;
  undoable?: boolean;
}

export const useNotification = (
  props: ICommonProps,
  notification: string,
  redirectTo: "list" | "edit" | "show" = "list"
) => {
  const { basePath, resource, undoable = true } = props;
  const notify = useNotify();
  const redirect = useRedirect();

  return (args: any) => {
    notify(
      `resources.${resource}.notifications.${notification}`,
      "info",
      {
        smart_count: 1,
      },
      undoable
    );
    redirect(redirectTo, basePath);
  };
};
